import React from 'react';
import { Link } from 'react-router-dom';
import PageChrome from '../../components/layout/PageChrome';
import travelOpportunities from '../../cms/travel.json';
import opportunities from '../../cms/opportunities.json';
import pageContent from '../../cms/page-content.json';
import '../../css/student-life/Opportunities.css';

const getCategoryStats = (path) => {
  switch (path) {
    case '/travel-opportunities':
      return {
        count: travelOpportunities.length,
        featured: travelOpportunities.filter((opp) => opp.applicationStatus === 'open').length,
      };
    case '/internship-opportunities':
      return {
        count: opportunities.length,
        featured: opportunities.filter((opp) => opp.applicationStatus === 'open').length,
      };
    default:
      return { count: 1, featured: 1 };
  }
};

const Opportunities = () => {
  const opportunityCategories = (pageContent.oppCategories || []).map((category) => ({
    ...category,
    ...getCategoryStats(category.path),
  }));

  return (
    <>
      <PageChrome
        title={pageContent.oppTitle}
        subtitle={pageContent.oppSubtitle}
        intro={pageContent.oppIntro}
      >
        <section className="opportunities-categories">
          <div className="categories-grid">
            {opportunityCategories.map((category) => (
              <Link 
                to={category.external ? undefined : category.path} 
                key={category.path} 
                className="category-card"
                onClick={category.external ? (e) => {
                  e.preventDefault();
                  window.open(category.path, '_blank', 'noopener,noreferrer');
                } : undefined}
                target={category.external ? "_blank" : undefined}
                rel={category.external ? "noopener noreferrer" : undefined}
              >
                <div className="category-icon">{category.icon}</div>
                <h3 className="category-title">{category.title}</h3>
                <p className="category-description">{category.description}</p>
                <div className="category-stats">
                  <span className="category-count">{category.count} {category.count === 1 ? 'opportunity' : 'opportunities'}</span>
                  {category.featured > 0 && (
                    <span className="category-featured">{category.featured} open</span>
                  )}
                </div>
                <div className="category-arrow">→</div>
              </Link>
            ))}
          </div>
        </section>

        <section className="opportunities-cta">
          <div className="cta-content">
            <h3>{pageContent.oppCtaTitle}</h3>
            <p>{pageContent.oppCtaText}</p>
            <Link to="/staff" className="cta-button">
              {pageContent.oppCtaButtonText}
            </Link>
          </div>
        </section>
      </PageChrome>
    </>
  );
};

export default Opportunities; 